import { inject } from '@angular/core';
import { Router } from '@angular/router';

import { MpsUserService } from '../../mps/services/mps-user.service';
import { MpsRoleHelper } from '../helpers/mps-role.helper';
import { MpsUser } from '../models/mps-user.model';

const REPORTING_ALLOWED_ROLES = [
  MpsRoleHelper.SUPER_ADMIN,
  MpsRoleHelper.CHEF_REGION,
  MpsRoleHelper.CHEF_SECTEUR,
  MpsRoleHelper.GERANT,
  MpsRoleHelper.HOTE_CAISSE,
];

export const ReportingGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl('/form');
  }

  const user = new MpsUser(loggedInUser);
  const hasAccess = user.role && REPORTING_ALLOWED_ROLES.includes(user.role.code.toUpperCase());
  return hasAccess ? true : router.navigateByUrl('/form');
};
